import { Helmet } from "react-helmet";

import AppBar from "./AppBar";
import Home from "./Home";
import About from "./About";
import Skills from "./Skills";
import Projects from "./Projects";
import Contact from "./Contact";

function MainLayout() {
  return (
    <>
      <Helmet>
        <title>Yuvaraj D</title>
        <meta name="description" content="Yuvaraj's personal portfolio" />
        <meta property="og:title" content="Yuvaraja D" />
        <meta
          property="og:description"
          content="Yuvaraj's personal portfolio"
        />
        <meta
          property="og:image"
          content="../assets/images/profile/profile.jpg"
        />

        <meta name="twitter:title" content="Yuvaraja D" />
        <meta
          name="twitter:description"
          content="Yuvaraj's personal portfolio"
        />
        <meta
          name="twitter:image"
          content="../assets/images/profile/profile.jpg"
        />
      </Helmet>
      <AppBar />
      <main>
        <article>
          <Home />
          <About />
          <Skills />
          <Projects />
          <Contact />
        </article>
      </main>
    </>
  );
}
export default MainLayout;
